import { render, staticRenderFns } from "./RecruitForm.vue?vue&type=template&id=2d21f73d"
import script from "./RecruitForm.vue?vue&type=script&lang=js"
export * from "./RecruitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports